import { FareBenefit, PaxWiseBaggage } from '@/src/types/itinerary'
import { processBaggageData } from '@/src/utils/itinerary/fareFamily'
import BaggageBenefit from './baggageBenefit'

const BaggageBenefitWrapper = ({
    beneift,
    onlyAdultBaggage = false,
    isTooltipContent = false,
    infoNotAvailableValues
}: {
    beneift: FareBenefit
    onlyAdultBaggage: boolean
    isTooltipContent: boolean
    benefitKey: string
    infoNotAvailableValues: string[]
}) => {
    const { paxWiseBaggages } = beneift || {}
    const { ADT = {} as PaxWiseBaggage, CHD = {} as PaxWiseBaggage, INF = {} as PaxWiseBaggage } = paxWiseBaggages || {}

    // Process baggage data for all passenger types
    const adultData = processBaggageData(ADT)
    const childData = processBaggageData(CHD)
    const infantData = processBaggageData(INF)

    return (
        <BaggageBenefit
            CHD={CHD}
            INF={INF}
            onlyAdultBaggage={onlyAdultBaggage}
            isTooltipContent={isTooltipContent}
            infoNotAvailableValues={infoNotAvailableValues}
            adultDisplayValue={adultData.displayValue}
            adultSubtext={adultData.subtext}
            isAdultBaggageWarningInfo={adultData.isWarningInfo}
            childDisplayValue={childData.displayValue}
            childSubtext={childData.subtext}
            isChildBaggageWarningInfo={childData.isWarningInfo}
            infantDisplayValue={infantData.displayValue}
            infantSubtext={infantData.subtext}
            isInfantBaggageWarningInfo={infantData.isWarningInfo}
        />
    )
}

export default BaggageBenefitWrapper
